import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row items-center q-mt-sm" }
const _hoisted_2 = { class: "row items-center q-mt-sm" }
const _hoisted_3 = { class: "row items-center q-mt-md" }

import { ref, computed, watch } from 'vue'
import { useRedeSubredeStore } from '@/stores/redeSubredeStore'
import type { QTableColumn } from 'quasar'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstitutionalFilterNetworkSubnetModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const redeSubredeStore = useRedeSubredeStore()

const props = __props
const emit = __emit

/* ===== PAGINAÇÃO (IGUAL AO PROTÓTIPO) ===== */
const pagination = ref({
  page: 1,
  rowsPerPage: 5
})

/* ===== REFS ===== */
const search = ref('')
const selectAllSubnets = ref(false)
const selectedRows = ref<any[]>([])

/* ===== WATCHERS ===== */
watch(
  () => props.modelValue,
  async (open) => {
    if (open) {
      await redeSubredeStore.carregarSubredes()
      pagination.value.page = 1
    }
  }
)

watch(selectAllSubnets, (checked) => {
  if (checked) {
    selectedRows.value = [...filteredRows.value]
  } else {
    selectedRows.value = []
  }
})

/* ===== COMPUTEDS ===== */
const rows = computed(() =>
  redeSubredeStore.subredes.map(s => ({
    id: s.codSubredeAutoAtndto,
    codigo: s.codSubredeAutoAtndto,
    subrede: s.nomSubredeAutoAtndto,
    rede: s.nomRedeAutoAtndto
  }))
)

const filteredRows = computed(() => {
  if (!search.value) return rows.value

  const termo = search.value.toLowerCase()
  const isNumero = !isNaN(Number(search.value))

  return rows.value.filter(r => {
    const matchNome = r.subrede.toLowerCase().includes(termo)
    const matchCodigo = isNumero && r.codigo === Number(search.value)

    return matchNome || matchCodigo
  })
})

const columns: QTableColumn[] = [
  { name: 'codigo', label: 'Código', field: 'codigo', align: 'left' },
  { name: 'subrede', label: 'Subrede', field: 'subrede', align: 'left' },
  { name: 'rede', label: 'Rede', field: 'rede', align: 'left' }
]

const confirm = () => {
  const subredesFormatadas = selectedRows.value.map(row => ({
    codRedeAutoAtndto: 1, // Banco24Horas
    codSubredeAutoAtndto: row.codigo,
    nomRedeAutoAtndto: row.rede,
    nomSubredeAutoAtndto: row.subrede
  }))

  redeSubredeStore.selecionarSubredes(subredesFormatadas)
  emit('update:modelValue', false)
}

const close = () => emit('update:modelValue', false)

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": __props.modelValue,
    persistent: "",
    "onUpdate:modelValue": _ctx.emitClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "modal-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-center justify-between" }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "modal-title" }, "Redes e Subredes", -1)),
              _createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                onClick: close
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "midia-app-caption-sm" }, "Pesquise uma Subrede", -1)),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  dense: "",
                  class: "col q-pr-sm",
                  label: "Rede *",
                  "model-value": "Banco24Horas",
                  readonly: ""
                }),
                _createVNode(_component_q_checkbox, {
                  dense: "",
                  label: "Selecionar Todas",
                  disable: ""
                })
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  dense: "",
                  class: "col q-pr-sm",
                  label: "Subredes *",
                  "model-value": selectedRows.value.length ? 'Selecionadas' : '',
                  readonly: ""
                }, null, 8, ["model-value"]),
                _createVNode(_component_q_checkbox, {
                  dense: "",
                  label: "Selecionar Todas",
                  modelValue: selectAllSubnets.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectAllSubnets).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  dense: "",
                  class: "col q-pr-sm",
                  placeholder: "Pesquisar",
                  modelValue: search.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "search" })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_q_btn, {
                  color: "negative",
                  label: "Buscar",
                  "no-caps": ""
                })
              ]),
              _createVNode(_component_q_table, {
                flat: "",
                dense: "",
                class: "q-mt-md",
                "row-key": "id",
                rows: filteredRows.value,
                columns: columns,
                selection: "multiple",
                selected: selectedRows.value,
                "onUpdate:selected": _cache[2] || (_cache[2] = ($event: any) => ((selectedRows).value = $event)),
                pagination: pagination.value,
                "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((pagination).value = $event))
              }, null, 8, ["rows", "selected", "pagination"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "negative",
                label: "Continuar",
                "no-caps": "",
                onClick: confirm
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}
}

})